import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "multiple" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["title"]
const _hoisted_4 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        class: _normalizeClass(["option", {selected: $options.selected === idx}])
      }, [
        _createVNode(_component_Button, {
          class: "button",
          disabled: $props.disabled || $options.selected !== -1,
          primary: $options.selected === idx,
          tiny: "",
          onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
          onClick: $event => ($options.onAccept(idx))
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" Select ")
          ]))]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "primary", "onClick"]),
        _createElementVNode("div", {
          class: "option-content",
          disabled: $options.optionDisabled(idx)
        }, [
          _createElementVNode("div", {
            class: "title ellipsis",
            title: option.title
          }, _toDisplayString(option.title), 9 /* TEXT, PROPS */, _hoisted_3)
        ], 8 /* PROPS */, _hoisted_2)
      ], 2 /* CLASS */))
    }), 128 /* KEYED_FRAGMENT */)),
    ($props.skip || $props.skipAll)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "skip-block",
          disabled: $props.disabled
        }, [
          ($props.skip)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "ai-option skip",
                onClick: $options.onSkip
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode(" Skip ")
                ])),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"]))
            : _createCommentVNode("v-if", true),
          ($props.skipAll)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: "ai-option skip",
                onClick: $options.onSkipAll
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" Skip All ")
                ])),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"]))
            : _createCommentVNode("v-if", true)
        ], 8 /* PROPS */, _hoisted_4))
      : _createCommentVNode("v-if", true)
  ]))
}